import React, { ReactNode } from 'react';
import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextField, { TextFieldProps } from '@mui/material/TextField';

import { ChevronDownIcon } from 'src/shared/components/icons';
import { useTranslate } from 'src/shared/providers';

import { Tooltip } from './Tooltip';

interface Props<T> extends Omit<AutocompleteProps<T, boolean, boolean, false>, 'renderInput'> {
  placeholder?: string;
  error?: boolean;
  inputTooltip?: ReactNode;
  InputProps?: TextFieldProps['InputProps'];
  inputProps?: TextFieldProps['inputProps'];
  _input?: TextFieldProps['sx'];
}

export const SearchBar = <T,>({
  placeholder,
  error,
  inputTooltip,
  sx,
  InputProps,
  inputProps,
  _input,
  ...props
}: Props<T>) => {
  const { t } = useTranslate();

  return (
    <Autocomplete
      // Input
      renderInput={({ ...params }) => (
        <Tooltip title={inputTooltip} showIcon={false}>
          <TextField
            onMouseDown={(ev) => ev.stopPropagation()}
            {...params}
            InputProps={{
              ...params.InputProps,
              ...InputProps,
              endAdornment: (
                <>
                  {props.loading ? <CircularProgress size={20} /> : null}
                  {InputProps?.endAdornment}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            inputProps={{ ...params.inputProps, ...inputProps }}
            placeholder={placeholder}
            error={error}
            autoComplete="off"
            sx={{ '& .MuiInputBase-root': { py: '0 !important' }, ..._input }}
          />
        </Tooltip>
      )}
      // Slots
      popupIcon={<ChevronDownIcon />}
      // Localizations
      loadingText={t('global.loading')}
      clearText={t('global.clear')}
      closeText={t('global.close')}
      noOptionsText={t('global.noOptions')}
      openText={t('global.open')}
      // UX
      clearOnBlur={false}
      // Styles
      sx={{ ...sx }}
      // Props overrides
      {...props}
    />
  );
};
